import * as $http from 'axios'

export default {
    all: () => $http.get('v2/refunds'),
    accept: refundId => $http.put(`v2/refunds/${refundId}/accept`),
    reject: (refundId, data) => $http.put(`v2/refunds/${refundId}/reject`, data),
}